import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";

import { theme } from "./theme";

import Dashboard from "./components/pages/Dashboard";
import TableView from "./components/pages/TableView";
import TableDataView from "./components/pages/TableDataView";
import NotFound from "./components/pages/NotFound";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 1000 * 60 * 5,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Toaster
          position="top-right"
          toastOptions={{
            style: { background: "#151922", color: "#fff" },
          }}
        />
        <Router>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/table/:schema/:tableName" element={<TableView />} />
            <Route path="/data/:schema/:tableName" element={<TableDataView />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
